<template>
  <MUIListItem
    :class="classNames"
    :text="recipe.parentedTitle"
    :secondaryText="secondaryText">
    <div
      slot="meta"
      v-lazy:background-image="recipe.imageUrl('list')"
      v-if="recipe.hasImage">
        <img :src="recipe.imageUrl('placeholder')" style="display: none" />
    </div>
  </MUIListItem>
</template>

<script>
import MUIListItem from '../MUIListItem'
export default {
  name: 'RecipeListItem',
  components: {
    MUIListItem
  },
  props: {
    isSelected: {
      type: Boolean,
      default: false
    },
    recipe: {
      type: Object,
      required: true
    }
  },
  computed: {
    classNames () {
      return {
        'is-selected': this.isSelected,
        'is-processing': this.recipe.isProcessing
      }
    },
    secondaryText () {
      if (this.recipe.isProcessing) return 'processing...'
      return this.recipe.domain
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Recipe/ListItem.vue